module.exports = __webpack_public_path__ + "img/doc-xs.abc8427b.jpg";